/**
 * FinanceApp - Copyright (c) 2026 Emmanuel TESTE
 * Tous droits réservés - Logiciel propriétaire
 */
// ── CustomFieldsForm — affiche les champs perso dans un formulaire ────────
// Props:
//   fields  : [{id, field_label, field_type, field_options, is_required}]
//   values  : { [field_id]: value }
//   onChange: (field_id, value) => void
//   style   : object (optionnel, style du conteneur)
export default function CustomFieldsForm({ fields = [], values = {}, onChange, style }) {
  if (!fields.length) return null;

  const inp = {
    width: "100%", background: "#0f172a", border: "1px solid #334155",
    borderRadius: 6, padding: "8px 10px", color: "#e2e8f0", fontSize: 13,
  };
  const lbl = { fontSize: 12, color: "#94a3b8", display: "block", marginBottom: 4 };

  return (
    <div style={style}>
      <div style={{ fontWeight: 600, color: "#e2e8f0", fontSize: 13, marginBottom: 12 }}>
        Informations complémentaires
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))", gap: 12 }}>
        {fields.map(f => {
          const val = values[f.id] ?? "";
          const opts = Array.isArray(f.field_options) ? f.field_options : [];
          const required = !!f.is_required;

          return (
            <div key={f.id} style={f.field_type === "textarea" ? { gridColumn: "1 / -1" } : {}}>
              <label style={lbl}>
                {f.field_label}
                {required && <span style={{ color: "#ef4444", marginLeft: 3 }}>*</span>}
              </label>
              {f.field_type === "text" && (
                <input style={inp} value={val} required={required}
                  onChange={e => onChange(f.id, e.target.value)} />
              )}
              {f.field_type === "number" && (
                <input style={inp} type="number" value={val} required={required}
                  onChange={e => onChange(f.id, e.target.value)} />
              )}
              {f.field_type === "date" && (
                <input style={inp} type="date" value={val} required={required}
                  onChange={e => onChange(f.id, e.target.value)} />
              )}
              {f.field_type === "url" && (
                <input style={inp} type="url" value={val} required={required}
                  placeholder="https://"
                  onChange={e => onChange(f.id, e.target.value)} />
              )}
              {f.field_type === "textarea" && (
                <textarea style={{ ...inp, height: 70, resize: "vertical" }} value={val} required={required}
                  onChange={e => onChange(f.id, e.target.value)} />
              )}
              {f.field_type === "select" && (
                <select style={inp} value={val} required={required}
                  onChange={e => onChange(f.id, e.target.value)}>
                  <option value="">— Choisir —</option>
                  {opts.map(o => <option key={o} value={o}>{o}</option>)}
                </select>
              )}
              {f.field_type === "checkbox" && (
                <label style={{ display: "flex", alignItems: "center", gap: 8, cursor: "pointer" }}>
                  <input type="checkbox" checked={val === "true" || val === true}
                    onChange={e => onChange(f.id, e.target.checked ? "true" : "false")}
                    style={{ width: 16, height: 16, accentColor: "#6366f1", cursor: "pointer" }} />
                  <span style={{ color: "#e2e8f0", fontSize: 13 }}>Oui</span>
                </label>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
